import { AxiosInstance } from 'axios';
import qs from 'qs';

import { OffsetPaginationInput } from '@app/data/inputs';
import { CollectionResource } from '@app/data/resources';

import { ClientUserFilterInput, CreateClientUserInput } from './inputs';
import { ClientUserRef } from './refs';
import { ClientUserListItemResource, ClientUserResource, ClientUserTeamConnectionsResource } from './resources';

export default class ClientUser {
    private basePath = '/api/client-user';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get client user list
    get = async (
        pagination: OffsetPaginationInput,
        filter?: ClientUserFilterInput
    ): Promise<CollectionResource<ClientUserListItemResource, {}>> => {
        const query = qs.stringify({ ...pagination, ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);

        return data;
    };

    // Create new client user
    create = async (input: CreateClientUserInput): Promise<ClientUserRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);

        return data;
    };

    // Get single client user
    getById = async (id: ID): Promise<ClientUserResource> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);

        return data;
    };

    // Get list of client team connections
    getTeamConnections = async (id: ID): Promise<CollectionResource<ClientUserTeamConnectionsResource, {}>> => {
        const { data } = await this.http.get(`${this.basePath}/${id}/connection/team`);

        return data;
    };

    // Attach team to a client user
    connectTeam = async (id: ID, teamId: ID): Promise<ClientUserRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}/connection/team/${teamId}`);

        return data;
    };

    // Delete client user team attachment
    removeTeamConnection = async (id: ID, teamId: ID): Promise<ClientUserRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}/connection/team/${teamId}`);

        return data;
    };
}
